import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  TrailerGroupsItem,
  TrailerGroupsList,
  TrailerHistoryList,
  TrailerItem,
  TrailerList,
} from './trailers.types';

@Injectable({
  providedIn: 'root',
})
export class ApiTrailersService {
  private readonly httpClient = inject(HttpClient);

  trailersList(): Observable<TrailerList> {
    return this.httpClient.get<TrailerList>('trailers/');
    // return of(this.generateTrailerItems());
  }

  trailerGroupsList(): Observable<TrailerGroupsList> {
    return this.httpClient.get<TrailerGroupsList>('trailers/groups/');
    // return of(this.generateTrailerGroups());
  }

  trailerItem(trailerId: number): Observable<TrailerItem> {
    return this.httpClient.get<TrailerItem>(`trailers/${trailerId}/`);
    // return of(this.generateTrailerItems());
  }

  trailersGroupItem(trailersGroupId: number): Observable<TrailerGroupsItem> {
    return this.httpClient.get<TrailerGroupsItem>(`trailers/groups/${trailersGroupId}/`);
    // return of(this.generateTrailerItems());
  }

  createTrailer(form: any): Observable<TrailerItem> {
    return this.httpClient.post<TrailerItem>('trailers/', form);
  }

  createTrailersGroup(form: any): Observable<TrailerGroupsItem> {
    return this.httpClient.post<TrailerGroupsItem>('trailers/groups/', form);
  }

  updateTrailer(trailerId: number, form: any): Observable<TrailerItem> {
    return this.httpClient.put<TrailerItem>(`trailers/${trailerId}/`, form);
  }

  updateTrailersGroup(trailerGroupId: number, form: any): Observable<TrailerGroupsItem> {
    return this.httpClient.put<TrailerGroupsItem>(`trailers/groups/${trailerGroupId}/`, form);
  }

  assignTrailer({ objectId, trailerId }: { objectId: number; trailerId: number }) {
    return this.httpClient.post(`trailer/attach/`, { trailerId, objectId });
  }

  deAttachTrailer(trailerId: number) {
    return this.httpClient.post(`trailer/deattach/`, { trailerId });
  }

  getTrailerPurposeHistory(trailerId: number): Observable<TrailerHistoryList[]> {
    return this.httpClient.get<TrailerHistoryList[]>(`trailer/history/${trailerId}/`);
  }

  deleteTrailer(trailerId: number) {
    return this.httpClient.delete(`trailers/${trailerId}/`);
  }

  deleteGroupTrailer(trailerGroupId: number) {
    return this.httpClient.delete(`trailers/groups/${trailerGroupId}/`);
  }

  generateTrailerItems(): TrailerList {
    const items: TrailerList = [];

    for (let i = 1; i <= 1000; i++) {
      items.push({
        id: i,
        name: `Trailer ${i}`,
        object: null,
        code: 'DEFAULT_CODE',
        description: 'Default description',
        isExcluding: false,
        workingWidth: null,
        customFields: [],
      });
    }

    return items;
  }

  generateTrailerGroups(count = 100): TrailerGroupsList {
    const groups: TrailerGroupsList = [];

    for (let i = 1; i <= count; i++) {
      const tiedTrailers: number[] = [];

      const trailerCount = Math.floor(Math.random() * 1000);
      for (let j = 0; j < trailerCount; j++) {
        const randomId = Math.floor(Math.random() * 1000) + 1; // ID от 1 до 100
        tiedTrailers.push(randomId);
      }

      groups.push({
        id: i,
        name: `Group ${i}`,
        description: 'Default group description',
        tiedTrailers,
      });
    }

    return groups;
  }
}
